import { Filter, TextInput } from "react-admin";

const ListFilters = (props: any) => (
  <Filter {...props}>
    <TextInput source="name" alwaysOn name="name" />
    <TextInput source="threshold" name="threshold" />
  </Filter>
);

export default ListFilters;
